// Utils
import equal from 'fast-deep-equal/es6';
import { resolveObjectOrNestedObjectsToObjectIds } from '../objectResolving';
/**
 * Builds an encoded change, converting any objects to encode object ids
 * @param {any} oldValue
 * @param {any} newValue
 *
 * @return
 */
export var constructChange = function (oldValue, newValue) {
    var oldValueMapped = resolveObjectOrNestedObjectsToObjectIds(oldValue);
    var newValueMapped = resolveObjectOrNestedObjectsToObjectIds(newValue);
    if (!equal(oldValueMapped, newValueMapped)) {
        return [oldValueMapped, newValueMapped];
    }
    // @todo this should really never happen, and this responsibility should be before this function
    //  see how it's used and remove equals if it never expects a null value
    return null;
};
//# sourceMappingURL=constructChange.js.map